import script from "./NewChat.vue?vue&type=script&setup=true&lang=js"
export * from "./NewChat.vue?vue&type=script&setup=true&lang=js"

import "./NewChat.vue?vue&type=style&index=0&id=11f77f45&lang=scss"

const __exports__ = script;

export default __exports__